import axios from 'axios';
// import i18n from '../i18n';
import duration from 'humanize-duration';
import { store } from '../App';
import { Auth } from 'aws-amplify';

// statement template
let statement = {
  actor: {},
  verb: {
    id: 'http://adlnet.gov/expapi/verbs/experienced',
    display: { 'en-US': 'verb' }
  },
  object: {
    id: 'http://example.com/activities/page-view',
    definition: {
      name: { 'en-US': 'activity' }
    }
  }
};
// get the endpoint to call. DEVELOPMENT just calls a sample json file.
const xapiEndpoint =
  process.env.NODE_ENV === 'development'
    ? '/content/xapi'
    : process.env.REACT_APP_XAPI_ENDPOINT;

// sets up Actor Endpoint for local vs production
// Note that Cognito (Review) is handled separately below in the getActor method
const actorEndpoint =
  process.env.NODE_ENV === 'development' ? '/xAPITest.json' : '/actorInfo.php';

// modify any data captured before sending off the statement
const enhanceData = data => {
  const now = new Date();
  let newData = {
    // timstamp: now.toString().replace(/:/g, '.'),
    timstamp: `${now}`.replace(/:/g, '.').split(' (')[0],
    courseKey: window.location.href.split('/').slice(-2)[0],
    locationIndicator: window.location.href.split('/').slice(-1)[0]
  };
  if (data) {
    Object.keys(data).forEach(datum => {
      newData[datum] =
        datum === 'duration' ? duration(data[datum]) : data[datum];
    });
  }
  return newData;
};

// tightening security
export const validatecanSendXapiRequests = () => {
  const {
    REACT_APP_XAPI_ENABLED,
    REACT_APP_XAPI_COURSES,
    REACT_APP_XAPI_ORIGINS
  } = process.env;
  const { courseId, actor } = store.getState().CourseState;
  const { hostname } = window.location;

  if (
    REACT_APP_XAPI_ENABLED === 'true' &&
    REACT_APP_XAPI_COURSES.split(',').includes(courseId) &&
    REACT_APP_XAPI_ORIGINS.includes(hostname) &&
    actor &&
    Object.keys(actor).length
  ) {
    return true;
  }
  return false;
};

// this method get passed to any component when uncluding this hook and using:
// const { xApiEvent } = useXapi();
export const xApiEvent = (verb, activity, data) => {
  // can we send a request?
  if (validatecanSendXapiRequests()) {
    // get the actor from state
    const {
      CourseState: { actor, language }
    } = store.getState();
    // clone the statement
    let stmnt = JSON.parse(JSON.stringify(statement));
    // populate the statement template values
    stmnt.actor = actor;
    stmnt.verb.display = { [language.code]: verb };
    stmnt.object.definition.name = { [language.code]: activity };
    stmnt.data = enhanceData(data);
    console.log('xAPI Data Being Sent:\n', JSON.stringify(stmnt, {}, 2));
    // call the endpoint to 'log' the xAPI event
    axios({
      method: 'PUT',
      url: xapiEndpoint,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      crossDomain: true,
      // pass the updated statement as the data
      data: stmnt
    })
      .then(response => {
        // eslint-disable-next-line no-console
        console.log('xAPI Response :\n', JSON.stringify(response.data, {}, 2));
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log('err :', err.response);
      });
  }
};
// Actor Info
export const actorInfo = async () => {
  let actor = { data: {} };
  // if xAPI is enabled
  if (process.env.REACT_APP_XAPI_ENABLED === 'true') {
    // if cognito in local or review
    if (
      ((process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_TEST_SECURITY === 'true') ||
        process.env.NODE_ENV === 'production') &&
      process.env.REACT_APP_SECURITY === 'cognito'
    ) {
      // get the cognito user
      const user = await Auth.currentAuthenticatedUser();
      // actor templates
      const actors = {
        xapi1: {
          data: {
            name: 'Shirley Manson',
            mbox: 'mailto:dumpsterfire@garbage.com',
            courseId: 'review'
          }
        },
        xapi2: {
          data: {
            name: 'Bilbo Baggins',
            mbox: 'mailto:hobbit@theshire.com',
            courseId: 'review'
          }
        },
        xapi3: {
          data: {
            name: 'Daenerys Targaryen',
            mbox: 'mailto:drgnlvr@kingslanding.com',
            courseId: 'review'
          }
        }
      };
      // pick an actor based on the user
      actor = actors[user.username] ? actors[user.username] : {};
    } else {
      // otherwise get actor info from local test json or JWT token
      actor = await axios.get(actorEndpoint);
    }
  }
  return actor.data;
};
